:host {
  .hide {
    display: none !important;
  }

  * {
    box-sizing: border-box;

    &:focus {
      outline: none;
    }
  }

  .faq-all {
    height: 100%;
    overflow-y: auto;
    padding-top: 16px;

    &--full {
      .faq-all-list {
        height: calc(100% - 230px);
      }
    }
  }

  .faq-all-search {
    position: relative;
    margin-bottom: 20px;

    input {
      width: 100%;
      padding: 12px;
      padding-left: 44px;
      border: none;
      font-size: 14px;
      color: #333333 !important;
      background: #f4f6fd;
      border: 1px solid #e7ebee;
      box-sizing: border-box;
      border-radius: 4px;
    }

    img {
      position: absolute;
      left: 12px;
      width: 16px;
      height: 16px;
      object-fit: contain;
      transform: translateY(-50%);
      top: 50%;
      filter: invert(54%) sepia(44%) saturate(7155%) hue-rotate(183deg) brightness(102%)
        contrast(109%);
      filter: var(--icon-blue);
    }
  }

  .faq-all-list {
    &__container {
      ul {
        position: relative;
        padding-left: 20px;
        list-style: none;
        margin: 15px 0;

        li {
          position: relative;
          margin-bottom: 5px;
          cursor: pointer;

          span {
            color: #0098ff;
            color: var(--blue);
            text-decoration: none;
            width: 100%;
            display: block;
            font-size: 15px;
            line-height: 22px;
          }

          img {
            position: absolute;
            left: -15px;
            top: 8px;
            width: 5px;
            height: 5px;
            object-fit: contain;
            filter: invert(54%) sepia(44%) saturate(7155%) hue-rotate(183deg) brightness(102%)
              contrast(109%);
            filter: var(--icon-blue);
          }
        }
      }
    }

    module-loader-component {
      height: 130px;
      display: block;
    }

    &__empty {
      display: block;
      text-align: left;
      color: #666;
      font-size: 16px;
      font-weight: normal;
      height: 50px;
      margin-right: 15px;
    }
  }

  .faq-all-action {
    margin-right: 15px;

    &__guides {
      a {
        border-radius: 8px 10px 10px 8px;
        margin-top: 20px;
        display: block;
        background: white;
        background: var(--bg-primary);
        padding: 20px;
        text-align: center;
        color: #333333;
        color: var(--font-primary);
      }
    }

    &__contact {
      display: block;
      margin-top: 20px;

      &.hide {
        display: none;
      }

      a {
        border-radius: 8px 10px 10px 8px;
        margin-top: 20px;
        display: block;
        background: #0098ff;
        background: var(--blue);
        padding: 20px;
        text-align: center;
        color: white;
        text-decoration: none;
        text-transform: uppercase;
        font-weight: 500;

        &:hover {
          transition: all 0.3s;
          background: #007ee2;
          background: var(--blue-hover);
        }
      }
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                FULL VERSION                                */
  /* -------------------------------------------------------------------------- */
  .faq-all--full {
    background: #f4f6fd;
    background: var(--bg-blue-manager);
    padding: 30px;
    box-sizing: border-box;
    border-radius: 6px;

    scrollbar-width: none;
    /* For Firefox */
    -ms-overflow-style: none;
    /* For Internet Explorer and Edge */

    &::-webkit-scrollbar {
      width: 0px;
      /* For Chrome, Safari, and Opera */
    }
  }
}
